import React from 'react';
import PropTypes from 'prop-types';
import { graphql, Link, useStaticQuery } from 'gatsby';
import './NavList.scss';

const Index = ({ sendTeaserImageUrl }) => {
	const data = useStaticQuery(graphql`
		query ARTICLE_LIST_QUERY {
			allMdx(sort: { fields: [frontmatter___date], order: DESC }) {
				nodes {
					id
					slug
					excerpt(pruneLength: 250)
					frontmatter {
						title
						date(formatString: "MMMM Do, YYYY")
						teaserImageUrl
					}
				}
			}
		}
	`);

	const hideHeaderNav = () => {
		document.querySelector('.layout__header-nav').classList.add('layout__header-nav--hidden');
		document.querySelector('.main-container').scroll(0, 0);
	};

	const showTeaserImage = frontmatter => {
		sendTeaserImageUrl(frontmatter.teaserImageUrl);
		document
			.querySelector('.header-background-image')
			.classList.add('header-background-image--visible');
	};

	const hideTeaserImage = () => {
		document
			.querySelector('.header-background-image')
			.classList.remove('header-background-image--visible');
	};

	return (
		<div className="nav__list">
			{data.allMdx.nodes.map(({ id, slug, frontmatter }) => (
				<Link
					to={'/' + slug}
					key={id}
					className="article__item-link-wrapper"
					onClick={hideHeaderNav}
					onMouseEnter={() => showTeaserImage(frontmatter)}
					onMouseLeave={() => hideTeaserImage()}>
					<article className="article__teaser">
						<div className="article__teaser-date">{frontmatter.date}</div>
						<h3 className="article__teaser-title">{frontmatter.title}</h3>{' '}
					</article>
				</Link>
			))}
		</div>
	);
};

export default Index;
